import * as React from 'react'
import { SVGProps } from 'react'
const SvgBook: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="book_svg__lucide book_svg__lucide-book-a-icon book_svg__lucide-book-a"
    {...props}>
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
    <path d="m8 13 4-7 4 7M9.1 11h5.7" />
  </svg>
)
export default SvgBook
